import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "label"]

  connect() {
    this.updateButton()
  }

  toggle(event) {
    event.preventDefault()
    this.element.classList.toggle("show-grid")
    this.updateButton()
  }

  updateButton() {
    if (!this.hasButtonTarget) return

    const showingGrid = this.element.classList.contains("show-grid")
    if (this.hasLabelTarget) this.labelTarget.textContent = showingGrid ? "Timetable als grid." : "Timetable per ruimte."
    this.buttonTarget.textContent = showingGrid ? "Liever per ruimte?" : "Liever de hele grid?"
    this.buttonTarget.setAttribute("aria-pressed", showingGrid ? "true" : "false")
  }
}
